import { Loadable } from '../../components/common/loadable/loadable';

export const LiveStreamsContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "live-streams" */ './live-streams').then(
      (module) => module.LiveStreamsContainer,
    ),
});
